function checkBrowser() {
    var ua = navigator.userAgent, tem,
    M      = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if(/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE';
    }

    if(M[1] === 'Chrome') {
        tem= ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');            
    }

    M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    
    return M.join(' ');
};

function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookies = decodeURIComponent(document.cookie).split(';');

    for(var i = 0; i < decodedCookies.length; i++) {

        var cookie = decodedCookies[i];
        cookie = cookie.trim();

        if (checkBrowser() === "IE") {
            if (cookie.indexOf(name)) {
                return cookie.substring(name.length, cookie.length);
            }
        } else {
            if (cookie.startsWith(name)) {
                return cookie.substring(name.length, cookie.length);
            }
        }
    }
    
    return "";
}

var cookieName = 'sace_cookie';
var cookieValue = getCookie(cookieName);

if (checkBrowser() === "IE") {
    window.onload = function() { 

        /**
         * The module provide a function that hide the button automatically, 
         * so these section should be commented.
        var acceptCookieButton = document.querySelector(".agree-button.eu-cookie-compliance-default-button");
        declineCookieButton.classList.add("button-cookie");
        declineCookieButton.onload = function() {
            document.location.reload();
        };
        */
        
        if(document.getElementById("remove-cookie") != null) {
            var deleteCookie = document.getElementById("remove-cookie");

            deleteCookie.onload = function() {
                let base = (drupalSettings.path.baseUrl).slice(0, -1);
                document.cookie = "sace_cookie=; expires=Thu, 18 Dec 2013 12:00:00 UTC; path="+base+"; SameSite=None; Secure";
                document.location.reload();
            };
        }

        if(document.querySelector(".decline-button.eu-cookie-compliance-secondary-button") != null) {
            var declineCookieButton = document.querySelector(".decline-button.eu-cookie-compliance-secondary-button");

            setTimeout(function() {
                if(+cookieValue > 0) {
                    // acceptCookieButton.style.display = "none";
                    declineCookieButton.style.display = "block"; 
                } else {
                    // acceptCookieButton.style.display = "block";
                    declineCookieButton.style.display = "none";
                }
            }, 500);
        }

    };
} else {
    window.addEventListener('DOMContentLoaded', (event) => {
        
        /**
         * The module provide a function that hide the button automatically, 
         * so these section should be commented.
        var acceptCookieButton = document.querySelector(".agree-button.eu-cookie-compliance-default-button");
        declineCookieButton.classList.add("button-cookie");
        declineCookieButton.addEventListener("click", function(){
            document.location.reload();
        });  
        */  
        
        if(document.getElementById("remove-cookie") != null) {
            var deleteCookie = document.getElementById("remove-cookie");

            deleteCookie.addEventListener("click", function() {
                if(checkBrowser().startsWith("Edge")) {
                    let base = (drupalSettings.path.baseUrl).slice(0, -1);
                    document.cookie = "sace_cookie=; expires=Thu, 18 Dec 2013 12:00:00 UTC; path="+base+"; SameSite=None; Secure";
                } else {
                    document.cookie = "sace_cookie=; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=; SameSite=None; Secure";
                }
                
                document.location.reload();
            });
        }
        
        if(document.querySelector(".decline-button.eu-cookie-compliance-secondary-button") != null) {
            var declineCookieButton = document.querySelector(".decline-button.eu-cookie-compliance-secondary-button");

            setTimeout(function() {
                if(+cookieValue > 0) {
                    // acceptCookieButton.style.display = "none";
                    declineCookieButton.style.display = "block"; 
                } else {
                    // acceptCookieButton.style.display = "block";
                    declineCookieButton.style.display = "none";
                }
            }, 500);
        }

    });
}